import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import {
    OpenSubmissionsDataState,
    OpenSubmissionsStreamState,
} from 'widgets/openSubmissions/store/stream/OpenSubmissionsStreamDataState';
import { useSelector } from 'react-redux';
import { WidgetType } from 'widgets/WidgetType';

export const selectOpenSubmissionsCapsuleWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.OPEN_SUBMISSIONS_CAPSULE];

export const selectOpenSubmissionsCapsuleState = (
    state: State,
    widgetKey: string
) => selectOpenSubmissionsCapsuleWidgetsState(state)[widgetKey];

export const selectStreamState: (
    state: State,
    widgetKey: string
) => OpenSubmissionsStreamState | undefined = (state, widgetKey) => {
    const widgetState = selectOpenSubmissionsCapsuleState(state, widgetKey);
    return widgetState?.stream;
};

export const selectStreamKey: (
    state: State,
    widgetKey: string
) => string | undefined = (state, widgetKey) => {
    const streamState = selectStreamState(state, widgetKey);
    return streamState?.streamKey;
};

export const selectStreamData: (
    state: State,
    widgetKey: string
) => OpenSubmissionsDataState | undefined = (state, widgetKey) => {
    const streamState = selectStreamState(state, widgetKey);
    return streamState?.data;
};

export const useSelectOpenSubmissionsCapsuleStreamData = (widgetKey: string) =>
    useSelector((state: State) => selectStreamData(state, widgetKey));
